module.exports = __webpack_public_path__ + "static/img/rank_188.5fbc5af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_188.png
// module id = oxS+
// module chunks = 0